module.exports = __webpack_public_path__ + "img/patientlist2.a1f60d8d.svg";